/* unplugin-vue-components disabled */import { render } from "./Layout6.vue.js?vue&type=template&id=e731397d!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Layout6.vue?vue&type=template&id=e731397d"
const script = {}

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__